import React from 'react';
import styles from './ABOProfile.module.scss';
import Icon from '../../common/Icon/Icon';
import { useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import HoverArrowLight from '../../../assets/images/LightTheme/hatv_hover_arrow.svg';
import HoverArrowDark from '../../../assets/images/DarkTheme/hatv_hover_arrow.svg';
import { KPI_KEYS } from '../../../../src/constants/dataConstants';

interface ABOProfile {
  aboNumber: string;
  aboName: string;
  aboCountry: string;
  flag: string;
  kpis: string;
  affiliateCode: string;
}

interface ABOProfileProps {
  profile?: ABOProfile;
  onSelect?: (profile: ABOProfile) => void;
  isSelected: boolean;
}

const ABOProfile: React.FC<ABOProfileProps> = ({ profile, onSelect, isSelected }) => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const { t } = useTranslation();
  const ArrowIcon = currentTheme === 'light' ? HoverArrowLight : HoverArrowDark;
  if (!profile) {
    return <div className={styles.no_profile}>{t('noProfileAvailable')}</div>;
  }

  const kpiDetails = Array.isArray(profile?.kpis)
    ? profile.kpis.map((kpi: KPI) => ({
        name: kpi.kpiName,
        value: kpi.kpiValue,
        flag: kpi.kpiFlag,
      }))
    : [];

  return (
    <div
      className={`profile_card ${styles.profile_card}`}
      style={{
        backgroundColor: isSelected ? (currentTheme === 'light' ? '#F4F4F4' : '#1C1C1E') : '',
        borderColor: isSelected ? (currentTheme === 'light' ? '#77CBBF' : '#007775') : '',
      }}
      onClick={() => {
        if (onSelect) onSelect(profile);
      }}
    >
      <div className={styles.content_container}>
        <div className={styles.content_wrapper}>
          <div className={styles.abo_name}>{profile.aboName}</div>
          <div className={styles.abo_details}>
            <div className={styles.details_wrapper}>
              {profile.aboNumber} | {profile.aboCountry}
            </div>
            <div className={`flag_wrapper ${styles.flag_wrapper}`}>
              {profile?.flag?.toLocaleLowerCase() === 'red' ? (
                <Icon
                  name="flag"
                  size={14}
                  color={currentTheme === 'light' ? '#D91734' : '#F16A81'}
                  className={styles.flag}
                />
              ) : profile?.flag?.toLocaleLowerCase() === 'yellow' ? (
                <Icon
                  name="flag"
                  size={14}
                  color={currentTheme === 'light' ? '#DA7600' : '#FED773'}
                  className={`${styles.flag}`}
                />
              ) : (
                <Icon
                  name="flag"
                  size={14}
                  color={currentTheme === 'light' ? '#107F47' : '#b3d67b'}
                  className={styles.flag}
                />
              )}
              <div
                className={
                  profile?.flag?.toLocaleLowerCase() === 'red'
                    ? `red_flag ${styles.flag_type}`
                    : profile?.flag?.toLocaleLowerCase() === 'yellow'
                      ? `yellow_flag ${styles.flag_type}`
                      : `green_flag ${styles.flag_type}`
                }
              >
                {t(profile.flag)}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`violation_desc ${styles.violation_desc}`}
          style={{
            color: currentTheme === 'light' ? '#707070' : '#AEAEB2',
          }}
        >
          {kpiDetails?.length > 0 ? (
            kpiDetails.map((kpi, index) => {
              const color =
                kpi?.flag?.toLocaleLowerCase() === 'red'
                  ? currentTheme === 'light'
                    ? '#D91734'
                    : '#F16A81'
                  : kpi?.flag?.toLocaleLowerCase() === 'yellow'
                    ? currentTheme === 'light'
                      ? '#DA7600'
                      : '#FED773'
                    : currentTheme === 'light'
                      ? '#2c2c2c'
                      : '#D8D8D9';
              return (
                <div key={index} className={styles.kpi_details}>
                  <span className={styles.kpi_wrapper}>
                    <span>{t(`kpi.${KPI_KEYS[kpi.name]}`) || kpi.name}</span>:
                    <div className={styles.value_wrapper}>
                      <span className={styles.value} style={{ color: color }}>
                        {kpi.value ?? '-'}
                      </span>
                      {(kpi?.flag?.toLocaleLowerCase() === 'yellow' ||
                        kpi?.flag?.toLocaleLowerCase() === 'red') && (
                        <div className={`flag_wrapper ${styles.flag_wrapper}`}>
                          <Icon name="flag" size={14} color={color} className={styles.flag} />
                        </div>
                      )}
                    </div>
                  </span>
                </div>
              );
            })
          ) : (
            <div className={styles.no_data}>{t('noDataAvailable')}</div>
          )}
        </div>
      </div>
      <div className={styles.arrow_icon} style={{ opacity: isSelected ? 0 : 1 }}>
        <img src={ArrowIcon} alt="Arrow Icon" />
      </div>
    </div>
  );
};

export default ABOProfile;
